import { rootStyle, rowStyle } from './styles';
import { IDummyProps } from './types';

export const overrides = (props: IDummyProps) => {
	return {
		Root: {
			style: ({ $theme }: any) => {
				return {
					...rootStyle(props),
				};
			},
			props: {
				'data-epo': 'epo-skeleton',
				'aria-hidden': true,
			},
		},
		Row: {
			style: ({ $theme }: any) => {
				return {
					...rowStyle(props),
				};
			},
			props: {
				'data-epo': 'epo-skeleton',
			},
		},
	};
};
